(function () {
  if (window.DouxcouReveal) return;

  const io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add("reveal-shown");
              io.unobserve(entry.target);
            });
          },
          { threshold: 0.1 },
        )
      : null;

  function scan(root) {
    (root || document).querySelectorAll("[data-reveal]:not(.reveal-shown)").forEach((el) => {
      if (el.dataset.revealBound) return;
      el.dataset.revealBound = "1";
      if (io) io.observe(el);
      else el.classList.add("reveal-shown");
    });
  }

  window.DouxcouReveal = { scan };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => scan());
  else scan();

  document.addEventListener("shopify:section:load", (e) => scan(e.target));
})();
